"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calulateReportingScoreSum = void 0;
const calculateProductIfrs_1 = require("./calculateProductIfrs");
const calulateReportingScoreSum = ({ tenant, shippingPrice, offsetShare, products, }) => {
    const shippingIfrs = (0, calculateProductIfrs_1.calculateShippingIfrs)(tenant, shippingPrice, offsetShare);
    const productsScoreSum = products.reduce((acc, product) => (product.metric5 ? acc + product.metric5 : acc), 0);
    return productsScoreSum + shippingIfrs;
};
exports.calulateReportingScoreSum = calulateReportingScoreSum;
//# sourceMappingURL=calulateReportingScoreSum.js.map